<template>
  <div class="role-info">
    <el-divider content-position="left">部门管理</el-divider>
    <el-row style="margin-bottom: 0.4rem">
      <el-col>
        <el-button type="primary" size="small" @click="handleAddOpen">新增</el-button>
        <el-button
          type="primary"
          size="small"
          @click.native="$router.push('setting_panel')"
          >返回上一级</el-button
        >
      </el-col>
    </el-row>

    <el-table
      height="calc(100vh - 276px)"
      :data="paramList"
      size="medium"
      style="width: 100%"
      border
    >
      <el-table-column label="ID" width="150">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="名称" width="200">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="部门领导" width="200">
        <template slot-scope="scope">
          {{ scope.row.adminuser.username }}
        </template>
      </el-table-column>
      <el-table-column label="部门描述" width="auto">
        <template slot-scope="scope">
          {{ scope.row.description }}
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-edit"
            circle
            @click="handleEditOpen(scope.$index, scope.row)"
            style="margin-right: 0.4rem"
          >
          </el-button>
          <el-popconfirm
            @onConfirm="handleDelete(scope.$index, scope.row)"
            confirmButtonText="确定"
            cancelButtonText="取消"
            icon="el-icon-info"
            iconColor="red"
            title="确定删除吗？"
          >
            <el-button
              size="mini"
              type="danger"
              slot="reference"
              icon="el-icon-delete"
              circle
            >
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <!--页码-->
    <el-footer class="page-footer">
      <el-pagination
        background
        class="pagination-style"
        layout="sizes, total, prev, pager, next, jumper"
        :hide-on-single-page="false"
        :current-page="pageOption.currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="pageOption.pageSize"
        :total="pageOption.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-footer>

    <!-- 添加-->
    <el-drawer
      title="添加/修改"
      :visible.sync="windowDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div class="m-tabs-content">
        <el-form :model="formData" label-width="120px" :rules="rules" ref="formData">
          <el-form-item label="部门名称" prop="name">
            <el-input
              type="text"
              size="mini"
              placeholder="请输入部门名称"
              v-model="formData.name"
            ></el-input>
          </el-form-item>
          <el-form-item label="部门领导" prop="leader">
            <el-select
              v-model="formData.leader"
              placeholder="请选择部门领导"
              size="mini"
              clearable
            >
              <el-option
                v-for="item in users"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="部门描述" prop="description">
            <el-input
              type="text"
              size="mini"
              placeholder="请输入部门描述"
              v-model="formData.description"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              style="float: right; margin-top: 0.4rem"
              size="mini"
              @click="submitCheckForm('formData')"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  name: "RoleInfo",
  data() {
    return {
      inputSize: "small",
      direction: "rtl",
      pageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      windowDrawer: false,
      paramList: [],
      users: [],
      formData: {
        id: "",
        name: "",
        leader: "",
        description: "",
      },
      rules: {
        name: [{ required: true, message: "请填写部门名称", trigger: "blur" }],
        leader: [{ required: true, message: "请选择部门领导", trigger: "blur" }],
      },
    };
  },
  computed: {
    collapse() {
      return this.$store.state.collapse;
    },
  },
  methods: {
    getPromoteParamList() {
      this.$axios
        .get(
          "/api/admin/company_branch/param/list?page=" +
            this.pageOption.currentPage +
            "&pageSize=" +
            this.pageOption.pageSize
        )
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.paramList = data.data.list.data;
            this.users = data.data.users;
            this.pageOption.total = data.data.list.total;
            this.pageOption.currentPage = data.data.list.current_page;
          }
        });
    },
    handleAddOpen() {
      this.windowDrawer = true;
    },
    submitCheckForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios
            .post("/api/admin/company_branch/param/add", { formData: this.formData })
            .then((res) => {
              let { data } = res;
              if (data.code === 0) {
                this.windowDrawer = false;
                this.getPromoteParamList();
                this.clearSaveData();
                this.$message.success(data.msg);
              } else {
                this.$message.error(data.msg);
              }
            });
        } else {
          return false;
        }
      });
    },
    handleEditOpen(index, row) {
      this.formData.id = row.id;
      this.formData.name = row.name;
      this.formData.leader = row.adminuser.id;
      this.formData.description = row.description;
      this.windowDrawer = true;
    },
    handleDelete(index, row) {
      this.$axios
        .get("/api/admin/company_branch/param/delete?id=" + row.id)
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.error(data.msg);
            this.getPromoteParamList();
          }
        })
        .catch((_) => {});
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getPromoteParamList();
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getPromoteParamList();
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.clearSaveData();
          done();
        })
        .catch((_) => {});
    },
    clearSaveData() {
      this.formData.id = "";
      this.formData.name = "";
      this.formData.leader = "";
      this.formData.description = "";
    },
  },
  mounted() {
    this.getPromoteParamList();
  },
};
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
@import '~styles/icon.styl'
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-drawer__wrapper >>> .el-drawer__header span
  color: #4c87fc
  font-size 0.36rem
  font-weight 400
.role-info
  marginLeft()
.mt-10
  margin-top: .2rem
.tr
  text-align: right
.m-tabs-content
  padding: 0 .2rem 0 .4rem
  overflow-y auto
  .m-label
    line-height: .64rem
  .el-row
    margin-bottom: .4rem
  .el-date-editor.el-input, .el-date-editor.el-input__inner
    width: 100%
  .el-select
    width: 100%
.role-info >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.addCon
  padding: .2rem
  text-align: right
.count_style
  display: inline-block
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
.page-footer
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px !important;
  background: #fff;
  width: 100%;
  z-index: 2;
.pagination-style
  padding-top: 25px;
  text-align: right;
</style>



// WEBPACK FOOTER //
// src/pages/count/RoleInfo.vue